import { CommonModule, NgFor, NgIf, SlicePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-branding-resources',
  imports: [NgFor, MatIconModule, NgIf, RouterModule,CommonModule],
  templateUrl: './branding-resources.component.html',
  styleUrl: './branding-resources.component.scss',
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class BrandingResourcesComponent {
  constructor(private titleService: Title, private metaService: Meta,private canonicalService: CanonicalService) {}
  ngOnInit(): void {
    this.titleService.setTitle(
      'Branding Resources | Logos & Marketing by MALtech'
    );

    this.metaService.updateTag({
      name: 'description',
      content:
        'Explore MALtech’s branding resources for creative logo design, visual identity, and digital marketing materials to elevate your business presence.',
    });

    this.metaService.updateTag({
      name: 'keywords',
      content:
        'Branding Resources, Logo Design, Marketing, Visual Identity, MALtech',
    });

    this.metaService.updateTag({
      name: 'robots',
      content: 'index, follow',
    });

    this.canonicalService.setCanonicalURL('resource/branding-resources/');



  }

  solutions = [
    {
      title: 'Consistency',
      description:
        'Maintain a consistent brand experience across all touchpoints.',
    },
    {
      title: 'Trust',
      description:
        'Build stronger customer relationships through a unified brand presence.',
    },
    {
      title: 'Growth',
      description:
        'Expand your market reach and revenue streams under your own brand.',
    },
  ];

  services = [
    {
      title: 'Custom UX/UI Design',
      description:
        'We craft digital experiences that mirror your brand identity. Every color, font, and interaction is designed to align with your guidelines, ensuring that customers instantly recognize your web and mobile platforms.',
      icon: 'bi-palette',
    },
    {
      title: 'Branded Communication Services',
      description:
        'All customer communications emails, SMS, WhatsApp alerts, and notifications are designed to carry your tone and visuals. Your customers will always see your brand’s name, logo and style.',
      icon: 'bi-chat-dots',
    },
    {
      title: 'Integration Services',
      description:
        'We seamlessly connect branded services and products into your ecosystem. From APIs to backend systems, every integration is delivered with your brand’s look and feel, giving customers a smooth, unified journey.',
      icon: 'bi-plug',
    },
    {
      title: 'White-Label SaaS Platforms',
      description:
        'We provide ready-to-use SaaS platforms that can be fully customized with your brand identity.',
      icon: 'bi-cloud',
    },
    {
      title: 'Branded Web & Mobile Apps',
      description:
        'Launch mobile and web applications that showcase your identity. Whether iOS, Android, or Web, we’ve got you covered.',
      icon: 'bi-phone',
    },
    {
      title: 'Domain & Email Branding',
      description:
        'We provide end-to-end domain and email branding solutions, setting up verified sender IDs and branded email addresses.',
      icon: 'bi-envelope',
    },
  ];

  benefits = [
    { text: 'Trust & Credibility' },
    { text: 'Consistency Across Channels' },
    { text: 'Speed & Efficiency' },
    { text: 'Scalability' },
    { text: 'Customer Loyalty' },
  ];

  reasons = [
    { text: 'Technology + Creativity' },
    { text: 'Proven Experience' },
    { text: 'Values That Drives Us' },
    { text: 'End-to-End Partner' },
  ];

steps = [
  {
    icon: 'bi-lightbulb',
    title: 'Consultation',
    desc: 'Understand your business goals and requirements.'
  },
  {
    icon: 'bi-pencil-square',
    title: 'Brand Customization',
    desc: 'Customize the platform with your brand identity.'
  },
  {
    icon: 'bi-code-slash',
    title: 'Development',
    desc: 'Develop and integrate your branded solution.'
  },
  {
    icon: 'bi-rocket-takeoff',
    title: 'Launch',
    desc: 'Deploy your branded solution.'
  },
  {
    icon: 'bi-headset',
    title: 'Support',
    desc: 'Continuous maintenance and technical support.'
  }
];

  scrollToProducts() {
    const plansSection = document.getElementById('products');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
